import styled from "styled-components";

const GAlign = styled.div`
  @media only screen and (max-width: 767px) {
    flex-wrap: ${(props) => {
      return props.mobwrap ? props.mobwrap : "nowrap";
    }};
    justify-content: ${(props) => {
      return props.mobalign ? props.mobalign : "left";
    }};
    align-items: ${(props) => {
      return props.mobalignV ? props.mobalignV : "left";
    }};
    flex-direction: ${(props) => {
      return props.mobdirection ? props.mobdirection : "row";
    }};
  }
  @media only screen and (max-width: 1024px) and (min-width: 768px) {
    flex-wrap: ${(props) => {
      return props.tabwrap ? props.tabwrap : "nowrap";
    }};
    justify-content: ${(props) => {
      return props.tabalign ? props.tabalign : "left";
    }};
  }
  display: flex;
  flex: 1;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: auto;
  gap: ${(props) => (props.gap ? props.gap : "0px")};
  flex-direction: ${(props) => (props.direction ? props.direction : "row")};
  justify-content: ${(props) =>
    props.align === "center"
      ? "center"
      : props.align === "left"
      ? "flex-start"
      : props.align === "right"
      ? "flex-end"
      : props.align === "between"
      ? "space-between"
      : props.align === "around"
      ? "space-around"
      : "flex-start"};
  align-items: ${(props) =>
    props.alignv === "top"
      ? "top"
      : props.alignv === "center"
      ? "center"
      : props.alignv === "baseline"
      ? "baseline"
      : props.alignv === "end"
      ? "end"
      : ""};
`;

export default GAlign;
